import AuthenticatedResource from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ContentResource extends AuthenticatedResource {
  static urlRoot = '/content'
  
  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}